export default [
    {
        path: '/',
        component: () => import('@/layouts/Main'),
        children: [
            { path: '', redirect: { name: 'restaurant-list' } },
            { path: '/', redirect: { name: 'restaurant-list' } },
            {
                path: '/login',
                name: 'login',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "auth" */ '@/views/LogIn'),
            },
            {
                path: '/login/callback',
                name: 'sso-login',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "auth" */ '@/views/Sso'),
            },
            {
                path: '/signup',
                name: 'signup',
                // companyCanteen scope: the global guard (router/index.js) sends "only Cloud
                // Canteen" users to canteen-pickup from every route outside the scope, before the
                // view's own beforeRouteEnter could handle an invite link (tasks#79)
                meta: { auth: true, scope: { companyCanteen: true } },
                component: () => import(/* webpackChunkName: "auth" */ '@/views/SignUp'),
            },
            {
                path: '/passwordreset',
                name: 'reset',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "auth" */ '@/views/ResetPassword'),
            },
            {
                path: '/activate',
                name: 'activate',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "auth" */ '@/views/Activate'),
            },
            {
                path: '/restaurants',
                name: 'restaurant-list',
                meta: { searchable: true, smallDevice: { showCart: true } },
                component: () =>
                    import(/* webpackChunkName: "restaurantList" */ '@/views/Restaurants/Page'),
            },
            {
                path: '/restaurants/featured',
                name: 'featured-restaurant-list',
                meta: { searchable: true, smallDevice: { showCart: true } },
                component: () =>
                    import(
                        /* webpackChunkName: "restaurantFeaturedList" */ '@/views/Restaurants/Featured'
                    ),
            },
            {
                path: '/restaurants/popular',
                name: 'popular-restaurant-list',
                meta: { searchable: true, smallDevice: { showCart: true } },
                component: () =>
                    import(
                        /* webpackChunkName: "restaurantPopularList" */ '@/views/Restaurants/Popular'
                    ),
            },
            {
                path: '/brand/:slug',
                name: 'brand-list',
                meta: { searchable: true, smallDevice: { showCart: true } },
                component: () =>
                    import(/* webpackChunkName: "restaurantBrand" */ '@/views/Brand/Page'),
            },
            {
                path: '/restaurant/:slug/:menu?',
                name: 'restaurant',
                meta: {
                    orderInProgress: true,
                    scope: { canteen: true, companyCanteen: true },
                    smallDevice: { hideOderDetails: true, showCart: true },
                },
                component: () =>
                    import(/* webpackChunkName: "restaurant" */ '@/views/Restaurant/Page'),
            },
            {
                path: '/restaurant/:type/:id/:slug/:menu?',
                name: 'restaurant-canteen',
                meta: {
                    orderInProgress: true,
                    scope: { canteen: true, companyCanteen: true },
                    smallDevice: { hideOderDetails: true, showCart: true },
                },
                component: () =>
                    import(/* webpackChunkName: "canteenRestaurant" */ '@/views/Restaurant/Page'),
            },
            {
                path: '/canteen',
                component: () =>
                    import(/* webpackChunkName: "canteenSelector" */ '@/views/Canteen/Page'),
                children: [
                    {
                        path: '/',
                        name: 'canteen-pickup',
                        meta: {
                            scope: {
                                canteenSelector: true,
                                canteen: true,
                                companyCanteen: true,
                            },
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "canteenSelector" */ '@/views/Canteen/views/Pickup'
                            ),
                    },
                    {
                        path: ':type/:location',
                        name: 'canteen-select',
                        meta: {
                            scope: {
                                canteenSelector: true,
                                canteen: true,
                                companyCanteen: true,
                            },
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "canteenSelector" */ '@/views/Canteen/views/Select'
                            ),
                    },
                ],
            },
            {
                path: '/checkout',
                name: 'checkout',
                meta: {
                    blockLocation: true,
                    blockDeliveryTime: true,
                    orderInProgress: true,
                    scope: {
                        canteen: true,
                        companyCanteen: true,
                    },
                },
                component: () => import(/* webpackChunkName: "checkout" */ '@/views/Checkout/Page'),
            },
            {
                path: '/order/:id',
                name: 'summary-page',
                meta: {
                    blockLocation: true,
                    blockDeliveryTime: true,
                    orderInProgress: true,
                    requiresAuth: true,
                    scope: {
                        companyCanteen: true,
                    },
                },
                component: () => import(/* webpackChunkName: "summary" */ '@/views/Summary/Page'),
            },
            {
                path: '/track/:id',
                name: 'track-page',
                component: () => import(/* webpackChunkName: "summary" */ '@/views/Summary/Page'),
            },
            {
                path: '/profile',
                component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile/Page'),
                children: [
                    {
                        path: 'general',
                        name: 'profile-general',
                        meta: {
                            requiresAuth: true,
                            scope: { companyCanteen: true },
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "profile" */ '@/views/Profile/views/General'
                            ),
                    },
                    {
                        path: 'notifications',
                        name: 'profile-notifications',
                        meta: {
                            requiresAuth: true,
                            scope: { companyCanteen: true },
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "profile" */ '@/views/Profile/views/Notifications'
                            ),
                    },
                    {
                        path: 'addresses',
                        name: 'profile-addresses',
                        meta: {
                            requiresAuth: true,
                            scope: { companyCanteen: true },
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "profile" */ '@/views/Profile/views/Addresses'
                            ),
                    },
                    {
                        path: 'payment-methods',
                        name: 'profile-payment-methods',
                        meta: {
                            requiresAuth: true,
                            scope: { companyCanteen: true },
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "profile" */ '@/views/Profile/views/PaymentMethods'
                            ),
                    },
                    {
                        path: 'allowances',
                        name: 'profile-allowances',
                        meta: {
                            requiresAuth: true,
                            scope: { companyCanteen: true },
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "profile" */ '@/views/Profile/views/Allowances'
                            ),
                    },
                    {
                        path: 'integrations',
                        name: 'profile-integrations',
                        meta: {
                            requiresAuth: true,
                            scope: { companyCanteen: true },
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "profile" */ '@/views/Profile/views/Integrations'
                            ),
                    },
                    {
                        path: 'orders/:page',
                        name: 'profile-orders',
                        meta: {
                            requiresAuth: true,
                            scope: { companyCanteen: true },
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "profile" */ '@/views/Profile/views/Orders'
                            ),
                    },
                ],
            },
        ],
    },

    {
        path: '/',
        component: () => import('@/layouts/NotFound'),
        children: [
            {
                path: '*',
                name: 'not-found',
                meta: { scope: { companyCanteen: true } },
                component: () => import(/* webpackChunkName: "notFound" */ '@/views/NotFound'),
            },
        ],
    },
]
